import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useCallback, useEffect, useMemo, useState } from 'react';
export const useLocalNotification = ({ windowsAppOnly = true, } = {}) => {
    const [permission, setPermission] = useState(() => {
        // Initialize from current Notification.permission
        // Or "denied" if we can't access Notification
        if (globalThis.Notification) {
            return globalThis.Notification.permission;
        }
        return 'denied';
    });
    const { device: { isWindowsApp }, } = useWebPlatform();
    // Keep local state in sync if Notification is supported
    useEffect(() => {
        // Check if notifications are supported
        if (globalThis.Notification) {
            if (globalThis.Notification.permission !== permission) {
                setPermission(globalThis.Notification.permission);
            }
        }
        // else do nothing if unsupported
    }, [permission]);
    // Request permission
    const requestPermission = useCallback(async () => {
        // No-op if unsupported
        if (globalThis.Notification) {
            // If we already have or lack permission, return early
            if (permission === 'granted')
                return true;
            if (permission === 'denied')
                return false;
            const newPermission = await globalThis.Notification.requestPermission();
            setPermission(newPermission);
            return newPermission === 'granted';
        }
        return false;
    }, [permission]);
    // Send a notification
    const sendNotification = useCallback(async ({ title, body, icon = 'https://r2cdn.perplexity.ai/pplx-desktop-icon.png', onClick, }) => {
        // If windows-only or unsupported, skip
        if (windowsAppOnly && !isWindowsApp) {
            return;
        }
        // Make sure permission is granted
        const hasPermission = await requestPermission();
        if (!hasPermission)
            return;
        // Create the notification
        if (globalThis.Notification) {
            const notification = new globalThis.Notification(title, {
                body,
                icon,
            });
            if (onClick) {
                notification.onclick = () => {
                    onClick();
                    window.focus();
                };
            }
        }
    }, [windowsAppOnly, isWindowsApp, requestPermission]);
    return useMemo(() => ({
        sendNotification,
        requestPermission,
        permission,
        isWindowsApp,
    }), [isWindowsApp, permission, requestPermission, sendNotification]);
};
//# sourceMappingURL=useLocalNotification.js.map